import React, {useState} from "react";
import {Col} from "react-bootstrap";
import Table from "../../Table/Table";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import {DateTime} from "luxon";
import {DATE_LOCALE} from "../../../Constants/constants";

export default function WaterConsumptionTable(props) {
    const resetFilters = () => {
        props.filtersRefs.current.forEach(currFilter => {
            if (currFilter) currFilter('');
        })
    }

    const toolbarComponents = <>
        <Col xs={{offset: 8, span: 4}} className={'WaterConsumptionData'}>
            <DateRangePicker
                startDate={props.startDate}
                endDate={props.endDate}
                setDateApplied={props.setDateApplied}
                setStartDate={props.setStartDate}
                setEndDate={props.setEndDate}
                hasExportCsv
                csvData={props.csvData}
                title={props.title}
            />
        </Col>
        <div className={'mt-1'}/>
    </>

    return (<div className={'WaterConsumptionTable'}>
        <Table
            keyField={'id'}
            data={props.data.data}
            columns={props.columns}
            pageSize={11}
            additionalToolbarComponent={toolbarComponents}
            csvFileName={`WaterConsumption_Report_${DateTime.local().toLocaleString({locale: DATE_LOCALE})}.csv`}
            resetFilters={resetFilters}
        />
    </div>)
}
